/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.AddOnGroup {
    angular.module('meevo.plugins.addOnGroup', []);
}